import { render } from "./inventario-coletor.vue?vue&type=template&id=39f88bb6&scoped=true"
import script from "./inventario-coletor.vue?vue&type=script&lang=js"
export * from "./inventario-coletor.vue?vue&type=script&lang=js"

import "./inventario-coletor.vue?vue&type=style&index=0&id=39f88bb6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f88bb6"]])

export default __exports__